import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Subscription} from 'rxjs/Subscription';
import {EmissionService} from 'services/emission.service';
import {SpinnerService} from 'services/spinner.service';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {Constants} from 'config/constants';

@Component({
    selector: 'tpc-meals',
    templateUrl: './meals.component.html',
    styleUrls: ['./meals.component.css']
})
export class MealsComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmited = false;

    public form: FormGroup;

    constructor(protected emissionService: EmissionService,
                protected footerService: FooterNavbarService,
                protected fb: FormBuilder,
                protected spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmited = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    private createForm() {
        this.form = this.fb.group({
            meals: [1, [Validators.required,
                CustomValidators.min(1), CustomValidators.max(99999999), CustomValidators.digits]],
            percentOfVeg: [0, [Validators.required,
                CustomValidators.min(0), CustomValidators.max(100), CustomValidators.digits]],
        });
    }

    private next() {
        let calculatorName = Constants.calculators.events;
        let categoryName = Constants.categories.events.meals;
        let params = {
            meals: this.getFV('meals'),
            percentOfVeg: this.getFV('percentOfVeg')
        };

        this.spinner.show();
        this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
            response => {
                let input = response.body[0].input[0];
                this.emissionService.setEmission({
                    category: categoryName,
                    emission: {
                        emission: input.emmission,
                        emissionTrees: input.emissionTrees,
                        DollarAmt: input.DollarAmt,
                        DollarAmtMonthly: input.DollarAmtMonthly
                    }
                });
                this.footerService.skip();
                this.spinner.hide();
            }
        );
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmited || this.form.get(param).touched);
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/events-calculator/meals/meals.component.ts